var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-view',{staticClass:"view z-depth-1"},[_c('mdb-mask',{staticClass:"mask-gradients"},[_vm._t("default",[_vm._v("There should be content code here...")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }